// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../../global/styles/buttonStyles";
import type { IconStylesClassesType } from "../../../global/styles/iconStyles";
import type { PanelStylesClassesType } from "../../../global/styles/generalStyles";
import { buttonStyles } from "../../../global/styles/buttonStyles";
import { iconStyles } from "../../../global/styles/iconStyles";
import { panelStyles } from "../../../global/styles/generalStyles";
import {
  GeneralModalForm,
  LoadingProgress,
  SnackbarMessage
} from "imagus-components";
import DisplayFace from "../people/DisplayFace";
import SearchResultList from "./SearchResultList";
import MatchedInfo from "./MatchedInfo";
import ExportCsvButton from "./ExportCsvButton";
import CreatePersonFormRedux from "../../containers/people/CreatePersonFormRedux";

const MESSAGE = [
  "Image has been successfully enrolled.",
  "Person has been successfully created."
];

const styles = (theme: DictionaryType): DictionaryType => ({
  ...panelStyles(theme),
  ...buttonStyles(theme),
  ...iconStyles(theme),
  carvedBar: {
    width: "100%",
    height: "auto",
    backgroundColor: theme.palette.grey.light,
    borderRadius: "2px",
    padding: "12px",
    boxshadow: "inset 0 1px 1px rgba(0,0,0,.05)",
    bordertop: "1px solid " + theme.palette.grey.main,
    marginBottom: "5px",
    textAlign: "right"
  },
  rightMargin: {
    marginRight: "5px"
  }
});

type FaceIdentifyStatesType = {
  activeItem: { [key: string]: string } | null,
  messageId: number,
  modalOpen: boolean,
  snackOpen: boolean
};

type FaceIdentifyClassesType = {
  ...PanelStylesClassesType,
  ...ButtonStylesClassesType,
  ...IconStylesClassesType,
  carvedBar: DictionaryType,
  rightMargin: DictionaryType
};

type FaceIdentifyPropsType = {
  classes: FaceIdentifyClassesType,
  setImageError: Function,
  faceSearch: { [key: string]: * },
  isV1Model: boolean,
  setCurrentFace: Function,
  getFaceFromEnrolment: Function,
  enrolMultiple: Function
};

class FaceIdentifyLayout extends Component<
  FaceIdentifyPropsType,
  FaceIdentifyStatesType
> {
  constructor(props: FaceIdentifyPropsType) {
    super(props);
    this.state = {
      activeItem: null,
      messageId: 0,
      modalOpen: false,
      snackOpen: false
    };
  }

  switchModalStatus =
    (modalName: string): * =>
    (status: boolean): * => {
      this.setState({ [modalName]: status });
    };

  handlePersonClick(result: { [key: string]: string }) {
    this.setState({
      activeItem: result
    });
  }

  setMessage = (val: boolean, index: number) => {
    if (index !== this.state.messageId) {
      this.setState({ messageId: index });
    }

    if (val) {
      this.switchModalStatus("snackOpen")(true);
    } else {
      this.switchModalStatus("snackOpen")(false);
    }
  };

  setCurrentFace = (img: string): * => {
    this.props.setCurrentFace(img);
  };

  getFaceFromEnrolment = (enrolmentId: string, doneCall: Function): * => {
    this.props.getFaceFromEnrolment(enrolmentId, doneCall);
  };

  render(): * {
    const classes = this.props.classes;
    const searchList =
      this.props.faceSearch.faceSearchResult &&
      this.props.faceSearch.faceSearchResult.searchResults;
    const searchStatus =
      this.props.faceSearch.faceSearchResult &&
      this.props.faceSearch.faceSearchResult.stats;

    let displayTags = false;
    if (searchList && searchList.length > 0) {
      if ("tags" in searchList[0]) {
        displayTags = true;
      }
    }

    let displayProbability = true;
    if (this.props.isV1Model) {
      displayProbability = false;
    }

    return (
      <div>
        <div className={classes.appPanelContent}>
          <SnackbarMessage
            open={this.state.snackOpen}
            handleModalStatus={this.switchModalStatus("snackOpen")}
            message={MESSAGE[this.state.messageId]}
          />
          <Grid container spacing={24}>
            <Grid item xs={6} md={3}>
              <DisplayFace
                img={this.props.faceSearch.faceSearchImage}
                title="Uploaded Person"
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <DisplayFace
                img={this.props.faceSearch.currentFace}
                title="Identified Person"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MatchedInfo
                setImageError={this.props.setImageError}
                activeItem={this.state.activeItem}
                setMessage={this.setMessage}
                searchStatus={searchStatus}
                displayTags={displayTags}
                displayProbability={displayProbability}
                faceSearch={this.props.faceSearch}
                enrolMultiple={this.props.enrolMultiple}
              />
            </Grid>
          </Grid>
        </div>
        <div
          className={classNames(classes.appPanelContent, classes.appPanelTop)}
        >
          {searchList === undefined ? (
            <LoadingProgress />
          ) : (
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <div className={classes.carvedBar}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    className={classNames(classes.darkBtn, classes.rightMargin)}
                    onClick={(): Function =>
                      this.switchModalStatus("modalOpen")(true)
                    }
                  >
                    <PersonAddIcon
                      className={classNames(
                        classes.lightIcon,
                        classes.rightMargin
                      )}
                    />
                    Create Person
                  </Button>
                  <GeneralModalForm
                    title="Create Person"
                    open={this.state.modalOpen}
                    handleModalStatus={this.switchModalStatus("modalOpen")}
                    form={
                      <CreatePersonFormRedux
                        newEnrolments={[
                          {
                            enrolmentId: Date.now(),
                            imgUrl: this.props.faceSearch.loadedImage,
                            token: this.props.faceSearch.imgToken,
                            eyes: this.props.faceSearch.detectedFaces
                          }
                        ]}
                        // enrolments={[
                        //   {
                        //     enrolmentId: Date.now(),
                        //     imgToken: this.props.faceSearch.imgToken,
                        //     imgUrl: this.props.faceSearch.faceSearchImage,
                        //     imgEyes: this.props.faceSearch.searchedPerson
                        //   }
                        // ]}
                        onClose={(): Function =>
                          this.switchModalStatus("modalOpen")(false)
                        }
                        setMessage={this.setMessage}
                      />
                    }
                  />
                  <ExportCsvButton
                    searchList={searchList}
                    displayTags={displayTags}
                  />
                </div>
                <SearchResultList
                  searchList={searchList}
                  activeItem={this.state.activeItem}
                  handlePersonClick={this.handlePersonClick.bind(this)}
                  setCurrentFace={this.setCurrentFace}
                  getFaceFromEnrolment={this.getFaceFromEnrolment}
                  displayTags={displayTags}
                  displayProbability={displayProbability}
                />
              </Grid>
            </Grid>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(FaceIdentifyLayout);
